import React from 'react';
import {Alert, Icon, Link, Logo, Typography} from '@bonprix/design-system';
import CheckoutHeaderInfo from "@checkout/components/checkout-header-info/CheckoutHeaderInfo.jsx";

export default function CheckoutHeader({rootUrl, secureConnectionText, headerInfoMessage}) {
    return (
                <div className="checkout-header__outer">
                    {headerInfoMessage && !(typeof headerInfoMessage === "object" && Object.keys(headerInfoMessage).length === 0) &&
                        <Alert isOpen showCloseIcon={false} nonCritical status="success" >
                            {headerInfoMessage}
                        </Alert>
                    }
                    <div className="checkout-header__grid">

                        <Link href={window.location.origin + rootUrl}>
                            <div className="checkout-header__logo">
                                <Logo variant="bonprix" label="bonprix" />
                            </div>
                        </Link>

                        <div className="checkout-header__secure-connection">
                            <div className="checkout-header__secure-connection__text">
                                <Typography align="right">{secureConnectionText}</Typography>
                            </div>
                            <Icon variant="lock" />
                        </div>
                    </div>
                </div>
    );
}
